import React, { Component } from 'react';
import './App.css';
import { 
  BrowserRouter as Router, 
  Route, 
  Switch 
} from 'react-router-dom';

import Home from './components/home';
import UserAuthenticate from './components/userAuthentication';
import SignOut from './components/SignOut';

class App extends Component {
  render() { 
    return ( 
       <Router> 
           <div className="App"> 
            <Switch> 
              <Route exact path='/' component={Home}></Route> 
              <Route exact path='/**-**/signin' component={UserAuthenticate}></Route>
              <Route exact path='/**-**/signout' component={SignOut}></Route>
              <Route exact path='/**-**/oauth2' component={UserAuthenticate}></Route>
            </Switch> 
          </div> 
       </Router> 
   ); 
  } 
}

export default App;